"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _format = _interopRequireDefault(require("date-fns/format"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _propValidators = require("../utils/propValidators");

var _getNextMode = _interopRequireDefault(require("./utils/getNextMode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function formatValue(value, mode) {
  if (mode === 'month') {
    return (0, _format["default"])(value, 'MMMM YYYY');
  }

  return (0, _format["default"])(value, 'YYYY');
}

var CalendarHeader = function CalendarHeader(_ref) {
  var id = _ref.id,
      onNext = _ref.onNext,
      onPeriod = _ref.onPeriod,
      onPrevious = _ref.onPrevious,
      mode = _ref.mode,
      viewDate = _ref.viewDate;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grv-calendar__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grv-calendar__controls"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": "Previous " + mode,
    className: "grv-calendar__previous-button",
    id: id + "--previous",
    onClick: onPrevious,
    type: "button"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": "Change to " + (0, _getNextMode["default"])(mode) + " view",
    className: "grv-calendar__period-button",
    id: id + "--period",
    onClick: onPeriod,
    type: "button"
  }, formatValue(viewDate, mode)), /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": "Next " + mode,
    className: "grv-calendar__next-button",
    id: id + "--next",
    onClick: onNext,
    type: "button"
  })));
};

var propTypes = {
  id: _propTypes["default"].string.isRequired,
  mode: _propTypes["default"].oneOf(['month', 'year']).isRequired,
  onNext: _propTypes["default"].func.isRequired,
  onPeriod: _propTypes["default"].func.isRequired,
  onPrevious: _propTypes["default"].func.isRequired,
  viewDate: _propValidators.dateType.isRequired
};
CalendarHeader.propTypes = propTypes;
var _default = CalendarHeader;
exports["default"] = _default;